import React, { useState } from "react";
import NoImage from "../../assets/Images/employee.png";
import { Link, useLocation } from "react-router-dom";
import { CgMoreVertical } from "react-icons/cg";
import GeneralModal from "../../component/Modals/General.modal";
import ExperienceData from "./experienceData";
import { IoReturnUpBack } from "react-icons/io5";

const ViewCandidate = () => {
  const location = useLocation();
  const [activeUser, setActiveUser] = useState(null);
  const [activeData, setActiveData] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const profile = location.state.activeData;
  const handleViewCv = (cvURL) => {
    window.open(cvURL, "_blank");
  };

  // console.log("profile -->", profile);

  const handleMore = (userData) => {
    const id = userData?._id;
    // console.log("data -->", userData);
    if (activeUser === id) return setActiveUser(null);
    setActiveUser(id);
    setActiveData(userData);
  };
  const handleView = () => {
    console.log("data -->", activeData);
    setshowModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="w-full max-w-5xl mx-auto">
        {/* Header Section with Enhanced Design */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-200">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="relative">
              <img
                className="w-48 h-48 rounded-2xl object-cover shadow-md ring-2 ring-100"
                src={profile?.avatar || NoImage}
                alt={profile.fullName}
              />
              <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
            </div>
            <div className="text-center lg:text-left flex-1">
              <h1 className="text-4xl font-bold text-gray-900 mb-2">
                {profile.fullName}
              </h1>
              <p className="text-xl text-gray-600 font-medium mb-6">
                {profile?.jobTitle || "Software Engineer"}
              </p>
              {profile?.resume ? (
                <button
                  onClick={() => handleViewCv(profile?.resume)}
                  className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-200"
                >
                  View Resume
                </button>
              ) : (
                <div className="inline-flex items-center px-4 py-2 bg-red-50 text-red-600 rounded-lg border border-red-200">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-2"></span>
                  No resume available
                </div>
              )}
            </div>
          </div>
          <div className="absolute top-0 left-0 w-full mt-2 flex items-start justify-start gap-2">
            <Link
              to="/candidate"
              className="py-[7px] flex bg-red-400 text-white px-4 rounded-sm items-center justify-start gap-1"
            >
              <IoReturnUpBack />
              Back
            </Link>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-8">
          {/* Personal Information Section */}
          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
            <div className="flex items-center mb-6">
              <div className="w-1 h-6 bg-blue-600 rounded-full mr-3"></div>
              <h2 className="text-xl font-bold text-gray-800">
                Personal Information
              </h2>
            </div>
            <div className="space-y-3">
              {Object.entries(profile).map(([key, value]) => {
                if (
                  typeof value === "string" &&
                  key !== "fullName" &&
                  key !== "avatar" &&
                  key !== "resume"
                ) {
                  return (
                    <div
                      key={key}
                      className="p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                    >
                      <div className="flex">
                        <span className="w-1/3 text-sm font-medium text-gray-700 capitalize">
                          {key.replace(/([A-Z])/g, " $1")}
                        </span>
                        <span className="w-2/3 text-gray-600">{value}</span>
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>

          {/* Address & Guarantor Section */}
          <div className="space-y-6">
            {/* Address */}
            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
              <div className="flex items-center mb-4">
                <div className="w-1 h-6 bg-gray-600 rounded-full mr-3"></div>
                <h2 className="text-xl font-bold text-gray-800">Address</h2>
              </div>
              <p className="text-gray-600 leading-relaxed">
                {profile?.address}
              </p>
            </div>

            {/* Guarantor */}
            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200">
              <div className="flex items-center mb-4">
                <div className="w-1 h-6 bg-gray-600 rounded-full mr-3"></div>
                <h2 className="text-xl font-bold text-gray-800">Guarantor</h2>
              </div>
              {profile?.guarantor?.map((guarantor) => {
                return (
                  <div className="space-y-3">
                    <div className="p-2 rounded-lg hover:bg-gray-50=== transition-colors duration-200">
                      <span className="font-medium text-gray-700">Name: </span>
                      <span className="text-gray-600">{guarantor?.name}</span>
                    </div>
                    <div className="p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                      <span className="font-medium text-gray-700">Phone: </span>
                      <span className="text-gray-600">{guarantor?.phone}</span>
                    </div>
                    <div className="p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                      <span className="font-medium text-gray-700">Email: </span>
                      <span className="text-gray-600">{guarantor?.email}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Work Experience Section */}
        <div className="bg-white rounded-xl shadow-md p-8 border border-gray-200">
          <div className="flex items-center mb-8">
            <div className="w-1 h-6 bg-blue-600 rounded-full mr-3"></div>
            <h2 className="text-xl font-bold text-gray-800">Work Experience</h2>
          </div>
          {profile?.workExperience?.length > 0 ? (
            <div className="space-y-6">
              {/* {profile?.workExperience?.map((work, index) => ( */}
              <div
                // key={index}
                className="w-full overflow-x-auto "
              >
                <table className="w-full min-w-max">
                  <thead className="text-gray-800 text-sm">
                    <tr className="text-sm">
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        S/N
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        Company
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        Address
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        Position
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        Salary
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        Start
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        End
                      </th>
                      <th className="py-3 px-4 text-start whitespace-nowrap">
                        <CgMoreVertical className="text-gray-700" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {profile?.workExperience?.map((user, index) => (
                      <tr
                        key={user?._id}
                        className="text-gray-700 text-sm text-start"
                      >
                        <td className="py-3 px-4 text-center whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user.companyName}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user.companyAddress}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user.positionHeld}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user.salary}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user.startYear}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap">
                          {user?.finishYear}
                        </td>
                        <td className="py-3 px-4 text-start whitespace-nowrap relative">
                          <button
                            onClick={() => handleMore(user)}
                            className="hover:bg-gray-100 rounded-full"
                          >
                            <CgMoreVertical />
                          </button>

                          {activeUser === user?._id && (
                            <ul className="absolute top-6 right-12 w-36 bg-white shadow-md rounded-lg px-2 py-1 transform transition-all duration-200 ease-in-out animate-dropdown">
                              <li
                                onClick={() => handleView(user?.user)}
                                className="cursor-pointer hover:text-blue-200 mb-2 p-2"
                              >
                                view
                              </li>
                            </ul>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* ))} */}
            </div>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
              </div>
              <p className="text-gray-500 text-lg">
                No work experience available
              </p>
            </div>
          )}
        </div>
      </div>
      <GeneralModal
        handleClose={() => setshowModal(false)}
        open={showModal}
        width="2xl"
      >
        <ExperienceData work={activeData} />
      </GeneralModal>
    </div>
  );
};

export default ViewCandidate;
